var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditLasso1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 409,
    viewBox: "0 0 428 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10392_66504)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10392_66504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.699 2.69856C137.103 9.21976 110.97 25.8294 96.0701 53.9527C69.375 104.341 80.731 141.219 71.3955 178.452C62.06 215.686 33.4385 228.166 12.8529 257.308C-3.21506 280.055 -5.75321 335.383 23.0418 363.009C51.5294 390.124 77.7994 415.265 128.946 407.605C179.581 400.251 205.11 366.193 258.307 355.566C311.505 344.939 355.564 354.669 383.874 329.452C413.56 303.009 444.44 229.873 417.915 177.086C396.58 134.627 344.706 125.121 319.399 85.3223C294.091 45.5241 281.949 27.8027 260.121 18.2863C229.945 5.13063 207.238 -2.63028 175.699 2.69856Z",
    stroke: "white",
    strokeOpacity: 0.24,
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10392_66504",
    x: -167.159,
    y: -125.369,
    width: 763.318,
    height: 744.318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7898
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 83.5795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10392_66504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10392_66504",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10392_66504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 409,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLasso1);
export default __webpack_public_path__ + "static/media/edit-lasso1.5a0a25f5c2dd9c4862eece6e54797569.svg";
export { ForwardRef as ReactComponent };